import Vue from 'vue';
import Vuex from 'vuex';

// Import All Stores
import UserStore from './users.store';
import LoginStore from './login.store';
import TranshipmentStore from './transhipment.store';
import AdressStore from './adress.store';
import CouriersStore from './couriers.store';
import ShipmentStore from './shipment.store';
import ManifestStore from './manifest.store';
import AccountsStore from './accounts.store';
import AccountsReceivableStore from './accountsReceivable.store';
import QuarantineStore from './quarantine.store';
import NfeStore from './nfe.store';
import GivBackStore from './givback.store';
import QuarantineTransferStore from './quarantine-transfer.store';
import SidebarStore from './sidebar.store';
import ReportStore from './reports.store';
import ShippersStore from './shippers.store';
import ShippersReceivableStore from './shippersReceivable.store';
import TranshipmentTransfer from './modules/transhipmentTransfer';
import ExpandedManagementCardHandler from './modules/expandedManagementCard';
import ExpandedTranshipmentManagementCard from './modules/expandedTranshipmentManagementCard';
import ReceiptsManagementHandler from './modules/receiptsManagement';
import FeedbackMessageHandler from './modules/feedbackMessageHandler';
import InvoicesReceivableStore from './invoicesReceivable.store';
import ImportXmlStore from './importXml.store';
import ManualBoardingStore from './manualBoarding.store';
import ImportManualNfeStore from './importManualNfe.store';
import ImportManualDeliveryStore from './importManualDelivery.store';
import ImportManualStopsStore from './importManualStop.store';
import ImportManualCargosStore from './importManualCargo.store';
import ImportManualBoardingsStore from './importManualBoarding.store';
import ImportManualDashboardStore from './importManualDashboard.store';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    UserStore,
    LoginStore,
    TranshipmentStore,
    AdressStore,
    CouriersStore,
    ShipmentStore,
    ManifestStore,
    AccountsStore,
    AccountsReceivableStore,
    QuarantineStore,
    NfeStore,
    GivBackStore,
    QuarantineTransferStore,
    SidebarStore,
    ReportStore,
    TranshipmentTransfer,
    ExpandedManagementCardHandler,
    ExpandedTranshipmentManagementCard,
    ReceiptsManagementHandler,
    ShippersStore,
    ShippersReceivableStore,
    FeedbackMessageHandler,
    InvoicesReceivableStore,
    ImportXmlStore,
    ManualBoardingStore,
    ImportManualNfeStore,
    ImportManualDeliveryStore,
    ImportManualStopsStore,
    ImportManualCargosStore,
    ImportManualBoardingsStore,
    ImportManualDashboardStore
  }
});
